import { PlateInfoDTO } from 'business/models/Models';
import React from 'react';

type TProjectSidePanelContext = {
  selectedPlateList: PlateInfoDTO[];
  setSelectedPlateList: React.Dispatch<React.SetStateAction<PlateInfoDTO[]>>;
  onEditPlateBarcode: (plateId: number, barcode: string) => void;
};

const ProjectSidePanelContext = React.createContext<TProjectSidePanelContext>({
  selectedPlateList: [],
  setSelectedPlateList: (e) => {},
  onEditPlateBarcode: () => {},
});

export default ProjectSidePanelContext;
